// client/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';

// ✅ CRITICAL: Import order matters!
// Theme variables MUST come first
import './styles/theme-variables.css';  // 1️⃣ Default theme variables
import './index.css';                    // 2️⃣ Base reset/normalize styles
import './styles/mwc-layout.css';        // 3️⃣ Layout styles using variables
import './styles/mwc-cards.css';         // 4️⃣ Component styles using variables

import App from './App';
import reportWebVitals from './reportWebVitals';
import { QuizContextProvider } from './context/quizReducer';
import { ThemeProvider } from './context/ThemeContext';

// Get tenantId from URL query parameter or use default
const urlParams = new URLSearchParams(window.location.search);
const tenantId = urlParams.get('tenant') || 'demo-university';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider tenantId={tenantId}>
      <QuizContextProvider>
        <App />
      </QuizContextProvider>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();